@if (basket?.Charges) {
  <div class="basket-charges" id="basket-charges">
    @if (!showErrorsOnly) {
      <div class="basket-charge-total">
        @for (charge of charges; track $index) {
          <div class="basket-charge-list-item">
            <span>{{ charge.narrative }}</span>
            <div class="flex-row flex-center">
              <samp>{{ charge.price | currency : 'GBP'  }}</samp>
              @if (!orderComplete && charge.onDelete) {
                <span class="material-symbols-outlined delete-icon" (click)="charge.onDelete()">delete_forever</span>
              }
            </div>
          </div>
        }

        @if (showTotal && basketTotal > 0) {
          <div class="basket-charge-list-item basket-total">
            <span>Total</span>
            <samp>{{ basketTotal || 0 | currency : 'GBP' }}</samp>
          </div>
        }
      </div>
    }

    @if (basketIssues?.length > 0) {
      <div class="basket-charge-errors">
        @for (issue of basketIssues; track $index) {
          <span>{{ issue }}</span>
        }
      </div>
    }
  </div>
}
